// Sync modelId in labelRows with aiModelAssistantState

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Paper,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  DialogActions,
  DialogTitle,
  IconButton,
  Dialog,
  DialogContent,
  Grid,
  Menu,
  DialogContentText,
  CircularProgress,
} from "@mui/material";
import {
  fetchProjectLabels,
  editProjectLabel,
  addProjectLabels,
  fetchProjectLabelById,
  deleteProjectLabel,
  disableProjectLabel,
} from "../../store/slice/ProjectLabelSlice";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchModels } from "../../store/slice/ProjectTrainSlice";
import AddIcon from "@mui/icons-material/Add";
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { selectProjectById } from "../../store/slice/ProjectSlice";
import { ImageGalleryProps } from "../../types/interface";
import KeyIcon from "@mui/icons-material/Key";
import {
  addLabelMapping,
  fetchImageModelDetails,
  fetchLabelsConditionally,
  fetchListOfAiLabels,
  fetchListOfAiModels,
  updateLabelColor,
} from "../../store/slice/ProjectImagesUploadedSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  addAnnotator,
  addImageUploader,
  addTrainer,
  addValidator,
  fetchAnnotators,
  fetchCustomerUsers,
  fetchImageUploaders,
  fetchProjectTeam,
  fetchTrainers,
  fetchValidators,
  requestAccess,
  Team,
  updateAnnotator,
  updateImageUploader,
  removeImageAnnotator,
  removeImageUploader,
  updateTrainer,
  removeTrainer,
} from "../../store/slice/WorkFlowSlice";
import { useParams } from "react-router-dom";
import { VisionStudioSpinner } from "../../components";
import { startSpinner, stopSpinner } from "../../store/slice/UISlice";
import { toast } from "react-toastify";
import InlineLoader from "../../components/InlineLoader";
import { disabledIds, tooltips } from "../Train";
import ResponsiveTooltip from "../../components/CustomTooltip/CustomTooltip";
import { isDisabled } from "@testing-library/user-event/dist/utils";

// Font size constants for this component only
const FONT_SIZE_XS = "11px";
const FONT_SIZE_SM = "12px";
const FONT_SIZE_MD = "13px";
const FONT_SIZE_LG = "14px";
const FONT_SIZE_XL = "18px";
const FONT_SIZE_XXL = "22px";

interface Customer {
  trainTarget?: number;
  ownerId: string;
  userName: string;
  count?: number; // Current count of completed tasks
  target?: number; // Target number of tasks
  track?: boolean;
  projectId?: string;
  isImageUpload?: boolean;
  imageTarget?: number;
  isAnnotate?: boolean;
  annotationTarget?: number;
  isvalidate?: boolean;
  isTrain?: boolean;
  customerId?: string;
  // target?: number; // For training tasks (removed duplicate)
}

const MemberSummaryBox = React.memo(
  ({ members = [], type }: { members?: Customer[]; type?: string }) => {
    const safeMembers = useMemo(
      () => (Array.isArray(members) ? members : []),
      [members]
    );
    const totalCount = useMemo(
      () => safeMembers.reduce((sum, m) => sum + (m.count || 0), 0),
      [safeMembers]
    );
    const totalTarget = useMemo(
      () => safeMembers.reduce((sum, m) => sum + (m.target || 0), 0),
      [safeMembers]
    );
    const totalAnnotationTarget = useMemo(
      () => safeMembers.reduce((sum, m) => sum + (m.annotationTarget || 0), 0),
      [safeMembers]
    );
    // These must be called unconditionally
    const totalAnnotated = useMemo(
      () =>
        safeMembers.reduce(
          (sum, m) =>
            sum +
            (typeof m.count === "number" && !isNaN(m.count) ? m.count : 0),
          0
        ),
      [safeMembers]
    );
    const totalAssigned = useMemo(
      () =>
        safeMembers.reduce(
          (sum, m) =>
            sum +
            (typeof m.target === "number" && !isNaN(m.target) ? m.target : 0),
          0
        ),
      [safeMembers]
    );

    if (type === "upload") {
      return (
        <Box sx={summaryBoxStyle}>
          <Typography sx={summaryTextStyle}>
            Uploaded Images by members:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {totalCount}
            </span>
          </Typography>
          <Typography sx={summaryTextStyle}>
            Assigned Images to upload for this project:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {totalTarget}
            </span>
          </Typography>
        </Box>
      );
    }
    if (type === "annotate") {
      return (
        <Box sx={summaryBoxStyle}>
          <Typography sx={summaryTextStyle}>
            Annotated Images by members:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {totalAnnotated}
            </span>
          </Typography>
          <Typography sx={summaryTextStyle}>
            Assigned Images to annotate for this project:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {totalAssigned}
            </span>
          </Typography>
        </Box>
      );
    }
    return (
      <>
        <Box sx={summaryBoxStyle}>
          <Typography sx={summaryTextStyle}>
            Trained Models by members:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {" "}
              {totalCount}
            </span>
          </Typography>
          <Typography sx={summaryTextStyle}>
            Assigned Models to train for this project:{" "}
            <span style={{ marginLeft: 8, color: "#1976d2" }}>
              {totalTarget}
            </span>
          </Typography>
        </Box>
      </>
    );
  }
);

const summaryBoxStyle = {
  margin: "7px 0",
  borderRadius: "6px",
  padding: "12px",
  background: "rgb(225, 237, 251)",
  border: "1px solid #add3ff",
  textAlign: "center",
};
const summaryTextStyle = {
  fontSize: FONT_SIZE_MD,
  fontWeight: "600",
  color: "#8f8f8f",
  marginBottom: "8px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const WorkFlow: React.FC<ImageGalleryProps> = ({ id, taskType }) => {
  // States for each card
  const dispatch: AppDispatch = useDispatch();
  const { usersList, team } = useSelector((state: RootState) => state.workflow);

  const [uploadSearchTerm, setUploadSearchTerm] = useState<string>("");
  const [annotateSearchTerm, setAnnotateSearchTerm] = useState<string>("");
  const [validateSearchTerm, setValidateSearchTerm] = useState<string>("");
  const [trainSearchTerm, setTrainSearchTerm] = useState<string>("");
  // Remove global inlineLoading; use local state in renderAddMemberInput
  const [uploadMembers, setUploadMembers] = useState<Customer[]>([]);
  const [annotateMembers, setAnnotateMembers] = useState<Customer[]>([]);
  const [validateMembers, setValidateMembers] = useState<Customer[]>([]);
  const [trainMembers, setTrainMembers] = useState<Customer[]>([]);
  const [creator, setcreator] = useState<Team | null>(null);

  useEffect(() => {
    const customerId = localStorage.getItem("customerId") || ""; // fallback to empty string
    dispatch(fetchCustomerUsers(customerId));
    dispatch(fetchProjectTeam(lastParam));
  }, [dispatch]);

  // Refs for each input
  const uploadInputRef = useRef<HTMLInputElement | null>(null);
  const annotateInputRef = useRef<HTMLInputElement | null>(null);
  const validateInputRef = useRef<HTMLInputElement | null>(null);
  const trainInputRef = useRef<HTMLInputElement | null>(null);

  const [uploadPlaceholder, setUploadPlaceholder] = useState(
    "Add member to Upload"
  );
  const [annotatePlaceholder, setAnnotatePlaceholder] = useState(
    "Add member to Annotate"
  );
  const [validatePlaceholder, setValidatePlaceholder] = useState(
    "Add member to Validate"
  );
  const [trainPlaceholder, setTrainPlaceholder] = useState(
    "Add member to Train"
  );
  const url = window.location.pathname;
  const segments = url.split("/");
  const lastParam = segments.pop() || "";

  const getAvailableCustomers = useCallback(
    (allCustomers: Customer[], selectedMembers: Customer[]) =>
      allCustomers.filter(
        (customer) =>
          !selectedMembers.some((member) => member.ownerId === customer.ownerId)
      ),
    []
  );

  useEffect(() => {
    setcreator(team);
  }, [team]);

  const [loader, setLoader] = useState<boolean>(true);

  useEffect(() => {
    dispatch(fetchListOfAiModels(id));

    dispatch(fetchImageModelDetails(lastParam)).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        setAiModelAssistantState(response.payload);
      } else {
        setAiModelAssistantState("");
      }
    });

    // Track completion of all loader APIs
    let completed = 0;
    const total = 4;
    const checkAllDone = () => {
      completed++;
      if (completed === total) setLoader(false);
    };

    dispatch(fetchImageUploaders(lastParam || ""))
      .then((response) => {
        setUploadMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
        checkAllDone();
      })
      .catch(() => checkAllDone());
    dispatch(fetchAnnotators(lastParam || ""))
      .then((response) => {
        setAnnotateMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
        checkAllDone();
      })
      .catch(() => checkAllDone());
    dispatch(fetchValidators(lastParam || ""))
      .then((response) => {
        setValidateMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
        checkAllDone();
      })
      .catch(() => checkAllDone());
    dispatch(fetchTrainers(lastParam || ""))
      .then((response) => {
        setTrainMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
        checkAllDone();
      })
      .catch(() => checkAllDone());
  }, []);

  const handleSelectCustomer = (
    customer: Customer,
    // setMembers: React.Dispatch<React.SetStateAction<Customer[]>>,
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>,
    setShowSuggestions: React.Dispatch<React.SetStateAction<boolean>>,
    cardType: string
  ) => {
    // Define actionMap with all possible actions
    const actionMap = {
      upload: { isImageUpload: true },
      annotate: { isAnnotate: true },
      validate: { isvalidate: true }, // Note: Typo (should be 'isValidate')
      train: { isTrain: true },
    };

    // Check if the cardType is valid
    if (!(cardType in actionMap)) {
      console.error("Invalid cardType:", cardType);
      return; // Exit early if invalid
    }

    // Get the action properties for the given cardType
    const actionProperties = actionMap[cardType as keyof typeof actionMap];

    // Create the final payload
    const finalPayload = {
      projectId: lastParam,
      ownerId: String(customer.ownerId),
      customerId: localStorage.getItem("customerId") || "default-customer-id",
      isImageUpload: false,
      isAnnotate: false,
      isvalidate: false,
      isTrain: false,
      userName: customer.userName || "default-user-name", // Add this field
      ...actionProperties, // Override the relevant flag
    };

    console.log("Final payload with active action:", finalPayload);

    // Dispatch the action

    if (cardType == "upload") {
      dispatch(addImageUploader(finalPayload)).then((response) => {
        dispatch(fetchImageUploaders(lastParam || "")).then((response) => {
          setUploadMembers(
            Array.isArray(response?.payload) ? response.payload : []
          );
          setUploadPlaceholder("Add member to Upload");
        });
        // setUploadMembers(response?.payload);
      });
    } else if (cardType == "annotate") {
      dispatch(addAnnotator(finalPayload)).then((response) => {
        dispatch(fetchAnnotators(lastParam || "")).then((response) => {
          setAnnotateMembers(
            Array.isArray(response?.payload) ? response.payload : []
          );
          setAnnotatePlaceholder("Add member to Annotate");
        });
      });
    } else if (cardType == "validate") {
      dispatch(addValidator(finalPayload)).then((response) => {
        dispatch(fetchValidators(lastParam || "")).then((response) => {
          setValidateMembers(
            Array.isArray(response?.payload) ? response.payload : []
          );
          setValidatePlaceholder("Add member to Validate");
        });
      });
    } else if (cardType == "train") {
      dispatch(addTrainer(finalPayload)).then((response) => {
        dispatch(fetchTrainers(lastParam || "")).then((response) => {
          setTrainMembers(
            Array.isArray(response?.payload) ? response.payload : []
          );
          setTrainPlaceholder("Add member to Train");
        });
      });
    }

    // Update state
    // setMembers((prev) => [...prev, customer]);
    setSearchTerm("");
    setShowSuggestions(false);
  };
  // Render member list for each card
  const handleRemoveMember = (member: Customer, type: string) => {
    const confirmRemove = (msg: string) => window.confirm(msg);

    if (type === "upload") {
      const hasUploads = (member.count ?? 0) >= 1;
      const msg = hasUploads
        ? "This user uploaded some images. If you continue, any unassigned images will be made available for others.\n\nDo you want to continue?"
        : `Are you sure you want to remove member '${member.userName}'?`;
      if (!confirmRemove(msg)) return;

      dispatch(
        removeImageUploader({
          projectId: lastParam || "",
          ownerId: member.ownerId,
          userName: member.userName,
          customerId: member.customerId,
          isImageUpload: true,
        })
      ).then((response: any) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(fetchImageUploaders(lastParam || "")).then((response) => {
            setUploadMembers(
              Array.isArray(response?.payload) ? response.payload : []
            );
          });
        }
      });
      return;
    }

    if (type === "annotate" && (member.count ?? 0) > 0) {
      if (
        !confirmRemove(
          "This user has already annotated some images. If you continue, any unannotated images assigned to this user will be automatically unassigned and made available for others.\n\nDo you want to continue?"
        )
      ) {
        return;
      }
    } else if (type !== "upload") {
      if (
        !confirmRemove(
          `Are you sure you want to remove member '${member.userName}'?`
        )
      ) {
        return;
      }
    }

    const removeFromState = (
      setMembers: React.Dispatch<React.SetStateAction<Customer[]>>
    ) => {
      setMembers((prev) => prev.filter((m) => m.ownerId !== member.ownerId));
    };

    switch (type) {
      case "upload":
        // Already handled above, but keep for safety
        break;
      case "annotate":
        dispatch(
          removeImageAnnotator({
            projectId: lastParam || "",
            ownerId: member.ownerId,
            userName: member.userName,
            customerId: member.customerId,
            isAnnotate: true,
          })
        ).then((response: any) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(fetchAnnotators(lastParam || "")).then((response) => {
              setAnnotateMembers(
                Array.isArray(response?.payload) ? response.payload : []
              );
            });
            dispatch(fetchProjectTeam(lastParam)).then((response) => {
              if (response?.payload) setcreator(response.payload);
            });
          }
        });
        break;
      case "validate":
        removeFromState(setValidateMembers);
        break;
      case "train":
        dispatch(
          removeTrainer({
            projectId: lastParam || "",
            ownerId: member.ownerId,
            userName: member.userName,
            customerId: member.customerId,
            isTrain: true,
          })
        ).then((response: any) => {
          if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(fetchTrainers(lastParam || "")).then((response) => {
              setTrainMembers(
                Array.isArray(response?.payload) ? response.payload : []
              );
            });
            dispatch(fetchProjectTeam(lastParam)).then((response) => {
              if (response?.payload) setcreator(response.payload);
            });
          }
        });
        break;
      default:
        break;
    }
    console.log(`Removed member with id: ${member.ownerId} from type: ${type}`);
  };

  const renderMemberList = useCallback(
    (members: Customer[], type: string) => (
      <Box sx={{ maxHeight: "calc(100vh - 450px)", overflowY: "scroll" }}>
        {Array.isArray(members) &&
          members.map((member) => (
            <Box
              key={member.ownerId}
              sx={{
                margin: "1px 0",
                padding: "10px",
                borderLeft: "3px solid lightblue",
                boxShadow: "0px 0 6px #00000012",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: FONT_SIZE_LG,
                    color: "grey",
                    fontWeight: "bold",
                  }}
                >
                  {member.userName}
                </Typography>
                {type === "annotate" &&
                typeof member.target === "number" &&
                typeof member.count === "number" ? (
                  member.target - member.count > 0 ? (
                    <Typography
                      sx={{ fontSize: FONT_SIZE_XS, color: "#000000" }}
                    >
                      <span style={{ color: "#f7364d", fontWeight: 600 }}>
                        {member.target - member.count}
                      </span>{" "}
                      Unannotated Images
                    </Typography>
                  ) : member.target - member.count < 0 ? (
                    <Typography
                      sx={{ fontSize: FONT_SIZE_XS, color: "#000000" }}
                    >
                      <span style={{ color: "#1976d2", fontWeight: 600 }}>
                        {Math.abs(member.target - member.count)}
                      </span>{" "}
                      Images Annotated more than assigned
                    </Typography>
                  ) : null
                ) : type === "validate" &&
                  typeof member.target === "number" &&
                  typeof member.count === "number" ? (
                  <Typography sx={{ fontSize: FONT_SIZE_XS, color: "#000000" }}>
                    <span style={{ color: "#f7364d", fontWeight: 600 }}>
                      {member.target - member.count}
                    </span>{" "}
                    Unvalidated Images
                  </Typography>
                ) : null}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span
                  style={{
                    padding: "6px 11px",
                    border: "1px solid grey",
                    borderRadius: "16px",
                    fontSize: FONT_SIZE_SM,
                  }}
                >
                  {member.count ? member.count : 0}/
                  {member.target ? member.target : 0}
                </span>
                {creator?.ownerId === member.ownerId ? (
                  <KeyIcon
                    sx={{ color: "green", fontWeight: 600, marginLeft: 1 }}
                  />
                ) : (
                  <React.Suspense fallback={null}>
                    {creator?.currentUser === creator?.ownerId && (
                      <RemoveMemberIcon
                        onClick={() => handleRemoveMember(member, type)}
                      />
                    )}
                  </React.Suspense>
                )}
              </Box>
            </Box>
          ))}
      </Box>
    ),
    [creator]
  );
  // Lazy import RemoveMemberIcon
  const RemoveMemberIcon = React.lazy(() => import("./RemoveMemberIcon"));

  // Render add member input for each card
  const renderAddMemberInput = (
    searchTerm: string,
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>,
    setShowSuggestions: React.Dispatch<React.SetStateAction<boolean>>,
    showSuggestions: boolean,
    inputRef: React.RefObject<HTMLInputElement>,
    placeholder: string,
    setPlaceholder: React.Dispatch<React.SetStateAction<string>>,
    currentMembers: Customer[],
    type: string,
    inlineLoading: boolean,
    setInlineLoading: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const availableCustomers = getAvailableCustomers(usersList, currentMembers);
    const filteredCustomers = availableCustomers.filter((customer) =>
      customer.userName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Inline loader state for this input (per card)
    // const [inlineLoading, setInlineLoading] = React.useState(false);

    const handleBlur = () => {
      setShowSuggestions(false);
      if (!searchTerm) {
        if (type === "upload") setPlaceholder("Add member to Upload");
        else if (type === "annotate") setPlaceholder("Add member to Annotate");
        else if (type === "validate") setPlaceholder("Add member to Validate");
        else if (type === "train") setPlaceholder("Add member to Train");
        else setPlaceholder("Add Member");
      }
    };

    const handleInputChange = (e: any) => {
      setSearchTerm(e.target.value);
      setShowSuggestions(true);
    };

    const handleRequest = (type: any) => {
      dispatch(
        requestAccess({
          projectId: lastParam || "",
          ownerId: creator?.currentUser || "",
          access: type,
        })
      );
    };

    // Inline version of handleSelectCustomer
    const handleSelectCustomer = (
      customer: Customer,
      setSearchTerm: React.Dispatch<React.SetStateAction<string>>,
      setShowSuggestions: React.Dispatch<React.SetStateAction<boolean>>,
      cardType: string
    ) => {
      const actionMap = {
        upload: { isImageUpload: true },
        annotate: { isAnnotate: true },
        validate: { isvalidate: true },
        train: { isTrain: true },
      };
      if (!(cardType in actionMap)) {
        console.error("Invalid cardType:", cardType);
        return;
      }
      const actionProperties = actionMap[cardType as keyof typeof actionMap];
      const finalPayload = {
        projectId: lastParam,
        ownerId: String(customer.ownerId),
        customerId: localStorage.getItem("customerId") || "default-customer-id",
        isImageUpload: false,
        isAnnotate: false,
        isvalidate: false,
        isTrain: false,
        userName: customer.userName || "default-user-name",
        ...actionProperties,
      };
      setInlineLoading(true);
      const placeholderMap = {
        upload: "Add member to Upload",
        annotate: "Add member to Annotate",
        validate: "Add member to Validate",
        train: "Add member to Train",
      };

      if (cardType in placeholderMap) {
        setPlaceholder(placeholderMap[cardType as keyof typeof placeholderMap]);
      }

      if (cardType == "upload") {
        dispatch(addImageUploader(finalPayload)).then((response) => {
          dispatch(fetchImageUploaders(lastParam || "")).then((response) => {
            setUploadMembers(
              Array.isArray(response?.payload) ? response.payload : []
            );
            setInlineLoading(false);
          });
        });
      } else if (cardType == "annotate") {
        dispatch(addAnnotator(finalPayload)).then((response) => {
          dispatch(fetchAnnotators(lastParam || "")).then((response) => {
            setAnnotateMembers(
              Array.isArray(response?.payload) ? response.payload : []
            );
            setInlineLoading(false);
          });
        });
      } else if (cardType == "validate") {
        dispatch(addValidator(finalPayload)).then((response) => {
          dispatch(fetchValidators(lastParam || "")).then((response) => {
            setValidateMembers(
              Array.isArray(response?.payload) ? response.payload : []
            );
            setInlineLoading(false);
          });
        });
      } else if (cardType == "train") {
        dispatch(addTrainer(finalPayload)).then((response) => {
          dispatch(fetchTrainers(lastParam || "")).then((response) => {
            setTrainMembers(
              Array.isArray(response?.payload) ? response.payload : []
            );
            setInlineLoading(false);
          });
        });
      }
      setSearchTerm("");
      setShowSuggestions(false);
    };

    return (
      <>
        {creator?.currentUser == creator?.ownerId ? (
          <div
            className="addMemeberButton"
            style={{ position: "relative", minHeight: 48 }}
          >
            {inlineLoading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(255,255,255,0.7)",
                  zIndex: 20000,
                  borderRadius: 8,
                }}
              >
                <InlineLoader size={32} thickness={4} />
              </div>
            )}
            <div className="addMemeberButton" style={{ position: "relative" }}>
              <input
                type="text"
                className="full-input"
                placeholder={placeholder}
                value={searchTerm}
                onChange={handleInputChange}
                onBlur={handleBlur}
                onFocus={() => setPlaceholder("")}
                style={{
                  border: "1px solid #38f8d8e",
                  outline: "none",
                  background: "transparent",
                  position: "relative",
                  zIndex: "9999",
                  width: "100%",
                  boxSizing: "border-box",
                }}
                ref={inputRef}
                disabled={inlineLoading}
              />
              <div className="add-icon">
                <AddIcon className="addIcon" sx={{ color: "white" }} />
              </div>

              {showSuggestions && (
                <Paper
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    width: "100%",
                    maxHeight: 200,
                    overflowY: "auto",
                    zIndex: 3333,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    marginTop: "5px",
                  }}
                >
                  <List>
                    {filteredCustomers.length > 0 ? (
                      filteredCustomers.map((customer) => (
                        <ListItem key={customer.ownerId} disablePadding>
                          <ListItemButton
                            onMouseDown={() =>
                              handleSelectCustomer(
                                customer,
                                setSearchTerm,
                                setShowSuggestions,
                                type
                              )
                            }
                            disabled={inlineLoading}
                          >
                            <ListItemText primary={customer.userName} />
                          </ListItemButton>
                        </ListItem>
                      ))
                    ) : (
                      <ListItem>
                        <ListItemText primary="No results found" />
                      </ListItem>
                    )}
                  </List>
                </Paper>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
        {creator?.currentUser !== creator?.ownerId &&
          type === "upload" &&
          !uploadMembers?.some(
            (member) => member.ownerId === creator?.currentUser
          ) && (
            <div
              className="addMemeberButton"
              style={{
                cursor: "pointer",
                zIndex: "9",
              }}
              onClick={() => handleRequest(type)}
            >
              <input
                type="text"
                className="full-input"
                placeholder="Request Access"
                style={{
                  border: "1px solid #38f8d8e",
                  outline: "none",
                  background: "transparent",
                  position: "relative",
                  zIndex: "9999",
                  pointerEvents: "none",
                  cursor: "pointer",
                }}
                disabled
              />
              <div className="add-icon heart">
                <KeyIcon className="addIcon" sx={{ color: "white" }} />
              </div>
            </div>
          )}

        {creator?.currentUser !== creator?.ownerId &&
          type === "annotate" &&
          !annotateMembers?.some(
            (member) => member.ownerId === creator?.currentUser
          ) && (
            <div
              className="addMemeberButton"
              style={{
                cursor: "pointer",
                zIndex: "9",
              }}
              onClick={() => handleRequest(type)}
            >
              <input
                type="text"
                className="full-input"
                placeholder="Request Access"
                style={{
                  border: "1px solid #38f8d8e",
                  outline: "none",
                  background: "transparent",
                  position: "relative",
                  zIndex: "9999",
                  pointerEvents: "none",
                  cursor: "pointer",
                }}
                disabled
              />
              <div className="add-icon heart">
                <KeyIcon className="addIcon" sx={{ color: "white" }} />
              </div>
            </div>
          )}

        {creator?.currentUser !== creator?.ownerId &&
          type === "train" &&
          !trainMembers?.some(
            (member) => member.ownerId === creator?.currentUser
          ) && (
            <div
              className="addMemeberButton"
              style={{
                cursor: "pointer",
                zIndex: "9",
              }}
              onClick={() => handleRequest(type)}
            >
              <input
                type="text"
                className="full-input"
                placeholder="Request Access"
                style={{
                  border: "1px solid #38f8d8e",
                  outline: "none",
                  background: "transparent",
                  position: "relative",
                  zIndex: "9999",
                  pointerEvents: "none",
                  cursor: "pointer",
                }}
                disabled
              />
              <div className="add-icon heart">
                <KeyIcon className="addIcon" sx={{ color: "white" }} />
              </div>
            </div>
          )}
      </>
    );
  };

  // State for showing suggestions for each card
  const [showUploadSuggestions, setShowUploadSuggestions] = useState(false);
  const [showAnnotateSuggestions, setShowAnnotateSuggestions] = useState(false);
  const [showValidateSuggestions, setShowValidateSuggestions] = useState(false);
  const [showTrainSuggestions, setShowTrainSuggestions] = useState(false);

  const [open, setOpen] = React.useState(false);

  const [openAI, setOpenAI] = useState(false);
  const [aiModelAssistantState, setAiModelAssistantState] = useState("");
  // State for label mapping dialog rows
  const [labelRows, setLabelRows] = useState([
    {
      labelName: "",
      modelId: aiModelAssistantState,
      projectLabelId: "",
      projectId: lastParam,
    },
  ]);
  // Handlers for label mapping dialog
  const handleAddLabelRow = () =>
    setLabelRows((rows) => [
      ...rows,
      {
        labelName: "",
        modelId: aiModelAssistantState,
        projectLabelId: "",
        projectId: lastParam,
      },
    ]);
  const handleLabelRowChange = (
    idx: number,
    field: "labelName" | "modelId" | "projectLabelId" | "projectId",
    newValue: string
  ) => {
    setLabelRows((rows) =>
      rows.map((row, i) => (i === idx ? { ...row, [field]: newValue } : row))
    );
  };
  const handleRemoveLabelRow = (idx: number) => {
    setLabelRows((rows) => rows.filter((_, i) => i !== idx));
  };
  // Function to handle opening the dialog
  const handleClickOpenAI = () => {
    setOpenAI(true);
  };
  // Function to handle closing the dialog
  const handleCloseAI = () => {
    setOpenAI(false);
  };
  const [targetModalData, setTargetModalData] = useState<{
    members: Customer[];
    cardType: string;
  } | null>(null);
  const [value, setValue] = useState<number>(0); // Single value

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
  };
  const handleOpen = (members: Customer[], cardType: string) => {
    setTargetModalData({
      members: [...members],
      cardType,
    });
    setOpen(true);
  };

  const { listofAiModels, listofAiLabels } = useSelector(
    (state: RootState) => state.ProjectImagesUploaded
  );

  const { tasks } = useSelector((state: RootState) => state.Tasks);
  const handleClose = () => setOpen(false);
  const findNameById = (id: string) => {
    const item = tasks.find((entry) => entry.id === id);
    return item ? item.name : undefined;
  };
  const handleSave = () => {
    setLoader(true);
    if (!targetModalData) return;

    const { members, cardType } = targetModalData;
    const customerId = localStorage.getItem("customerId") || "";
    const projectId = lastParam;
    let updatedData = [];
    if (cardType === "train") {
      // For train, always include trainTarget for each member
      updatedData = members.map((user) => {
        const { target, ...rest } = user;
        return {
          ...rest,
          customerId,
          projectId,
          trainTarget:
            typeof user.trainTarget === "number" ? user.trainTarget : 0,
        };
      });
    } else {
      updatedData = members
        .filter((user) => "imageTarget" in user || "annotationTarget" in user)
        .map((user) => {
          const { target, ...rest } = user;
          return {
            ...rest,
            customerId,
            projectId,
          };
        });
    }

    const refreshAll = () => {
      dispatch(fetchImageUploaders(lastParam || "")).then((response) => {
        setUploadMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
      });
      dispatch(fetchAnnotators(lastParam || "")).then((response) => {
        setAnnotateMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
      });
      dispatch(fetchValidators(lastParam || "")).then((response) => {
        setValidateMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
      });
      dispatch(fetchTrainers(lastParam || "")).then((response) => {
        setTrainMembers(
          Array.isArray(response?.payload) ? response.payload : []
        );
      });
      dispatch(fetchProjectTeam(lastParam)).then((response) => {
        if (response?.payload) setcreator(response.payload);
      });
    };

    switch (cardType) {
      case "upload":
        setUploadMembers(members);
        dispatch(updateImageUploader(updatedData)).then(() => {
          setLoader(false);
          refreshAll();
          setValue(0);
        });
        break;
      case "annotate":
        setAnnotateMembers(members);
        dispatch(updateAnnotator(updatedData)).then(() => {
          setLoader(false);
          refreshAll();
          setValue(0);
        });
        break;
      case "validate":
        setValidateMembers(members);
        setLoader(false);
        refreshAll();
        break;
      case "train":
        setTrainMembers(members);
        dispatch(updateTrainer(updatedData)).then(() => {
          setLoader(false);
          refreshAll();
          setValue(0);
        });
        break;
      default:
        break;
    }

    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const project = useSelector((state: RootState) =>
    selectProjectById(state, lastParam)
  );

  const handleEditProjectLabel = async () => {
    if (currentOption) {
      setSelectedProjectLabelIdForEdit(currentOption);
      const response = await dispatch(fetchProjectLabelById(currentOption));
      const editableResult = response.payload[0];
      setLabelName(editableResult.name);
      setSelectedColor(editableResult.labelColor);
      //setObjectTracking(editableResult.objectTracking);
      setShowDiv(true);
      setAnchorEl(null);
    }
  };

  useEffect(() => {
    if (listofAiLabels?.length > 0) {
      setLabelRows(
        listofAiLabels.map((label) => ({
          labelName: label.labelName || label.name || "",
          modelId: label.modelId || aiModelAssistantState,
          projectLabelId: label?.projectLabelId?.toLowerCase() || "",
          projectId: lastParam,
        }))
      );
    }
  }, [listofAiLabels, aiModelAssistantState, lastParam]);

  const distributeTargets = () => {
    if (targetModalData?.members?.length) {
      const trackedMembers = targetModalData.members.filter((m) => m.track);
      const trackedCount = trackedMembers.length;

      if (trackedCount > 0) {
        const baseValue =
          trackedCount > 0 ? Math.floor(value / trackedCount) : 0;
        const remainder = trackedCount > 0 ? value % trackedCount : 0;

        let distributed = 0;

        const newMembers = targetModalData.members.map((member) => {
          if (member.track) {
            const extra = distributed === 0 ? remainder : 0;
            distributed++;
            if (targetModalData.cardType === "train") {
              const { target, ...rest } = member;
              return {
                ...rest,
                trainTarget: baseValue + extra,
              };
            }
            return {
              ...member,
              target: baseValue + extra,
              annotationTarget: baseValue + extra,
            };
          }
          if (targetModalData.cardType === "train") {
            const { target, ...rest } = member;
            return { ...rest, trainTarget: 0 };
          }
          // For annotate and upload, set to 0 if slider is 0
          return {
            ...member,
            target: value === 0 ? 0 : 0,
            annotationTarget: value === 0 ? 0 : 0,
          };
        });

        setTargetModalData((prev) =>
          prev ? { ...prev, members: newMembers } : null
        );
      }
    }
  };
  const { labels } = useSelector((state: RootState) => state.projectLabel);

  useEffect(() => {
    distributeTargets();
  }, [value]);

  const [uploadInlineLoading, setUploadInlineLoading] = useState(false);
  const [annotateInlineLoading, setAnnotateInlineLoading] = useState(false);
  const [validateInlineLoading, setValidateInlineLoading] = useState(false);
  const [trainInlineLoading, setTrainInlineLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [currentOption, setCurrentOption] = useState<string | null>(null);
  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setCurrentOption(optionId);
  };

  const handleMenuClose = () => {
    setSelectedProjectLabelIdForEdit("");
    setAnchorEl(null);
    setCurrentOption(null);
  };

  useEffect(() => {
    dispatch(fetchProjectLabels(lastParam))
      .unwrap()
      .then((response) => {
        if (response.length === 0) {
          toast.info("Add label to start annotating!");
        }
        // allLabelRef.current = response;
      });
  }, []);

  // Label creation state
  const [showDiv, setShowDiv] = useState(false);
  const [labelName, setLabelName] = useState("");
  const [selectedColor, setSelectedColor] = useState("#FFB300");
  const [selectedProjectLabelIdForEdit, setSelectedProjectLabelIdForEdit] =
    useState("");
  const [deleteProjectLabelModal, setDeleteProjectLabelModal] =
    useState<boolean>(false);

  const colors = [
    { value: "#FFB300", label: "Yellow" },
    { value: "#E57373", label: "Red" },
    { value: "#64B5F6", label: "Blue" },
    { value: "#81C784", label: "Green" },
    { value: "#BA68C8", label: "Purple" },
    { value: "#FFD54F", label: "Light Yellow" },
    { value: "#4DD0E1", label: "Cyan" },
    { value: "#A1887F", label: "Brown" },
    { value: "#90A4AE", label: "Grey" },
  ];

  const handleLabelNameChange = (e: any) => setLabelName(e.target.value);
  const handleLabelColorChange = (e: any) => setSelectedColor(e.target.value);
  const saveAnnotationLabel = async (e: React.FormEvent) => {
    toast.dismiss();
    e.preventDefault();

    if (!labelName) {
      toast.error("Please enter Label Name");
      return;
    }
    if (!selectedColor) {
      console.log(colors);
      toast.error("Please select Label Color");
      return;
    }

    const taskId: string | undefined = project?.taskTypeId;
    const taskName = taskId ? findNameById(taskId) : "Invalid ID";

    let objectTrackingVariable = false;

    if (taskName?.toLowerCase().includes("tracking")) {
      objectTrackingVariable = true;
    }

    const data = {
      id: selectedProjectLabelIdForEdit ? selectedProjectLabelIdForEdit : "",
      name: labelName.trim(),
      description: "Default Description",
      projectId: lastParam || "",
      type: "Rectangle",
      objectTracking: objectTrackingVariable,
      // slNo: 1,
      labelColor: selectedColor,
    };
    dispatch(startSpinner("Saving project label"));

    try {
      if (selectedProjectLabelIdForEdit) {
        await dispatch(editProjectLabel(data))
          .unwrap()
          .then(() => {
            const data = {
              labelId: selectedProjectLabelIdForEdit,
              color: selectedColor,
            };
            dispatch(updateLabelColor(data));

            toast.success("Project Label updated Successfully");
          });
        await dispatch(fetchProjectLabels(lastParam));
      } else {
        await dispatch(addProjectLabels(data))
          .unwrap()
          .then((response) => {
            dispatch(fetchProjectLabels(lastParam));
            toast.success("Project Label added Successfully");
          });
      }
    } catch (error) {
      //toast.error("Failed to save Label");
    } finally {
      dispatch(stopSpinner());
      setShowDiv(false);
      //setObjectTracking(false);
      setLabelName("");
      setSelectedProjectLabelIdForEdit("");
    }
  };
  const cancelLabelCreation = (e: any) => {
    e.preventDefault();
    setShowDiv(false);
    setLabelName("");
    setSelectedColor("#FFB300");
  };

  const handleDeleteLabelClose = () => {
    setDeleteProjectLabelModal(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  const getTooltipById = (id: string): string => {
    // Convert the input ID to lowercase to match the keys in the tooltips object
    const lowercaseId = id.toLowerCase();

    // Return the tooltip if the ID exists, otherwise return a default message
    return tooltips[lowercaseId] || "No tooltip found for the given ID.";
  };

  const [isConfirmLoading, setIsConfirmLoading] = useState(false);

  const handleProjectLabelDelete = async () => {
    try {
      dispatch(startSpinner("Deleting project label"));
      if (currentOption) {
        await dispatch(deleteProjectLabel(currentOption))
          .unwrap()
          .then((result) => {
            handleMenuClose();
            setDeleteProjectLabelModal(false);
            localStorage.setItem("popupOpen", false.toString());
            toast.success("Project Label deleted Successfully");
          });
      }
      dispatch(stopSpinner());
    } catch (e) {
      setDeleteProjectLabelModal(false);
      localStorage.setItem("popupOpen", false.toString());
      handleMenuClose();
      dispatch(stopSpinner());
    }
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLabelRows((rows) =>
      rows.map((row, idx) =>
        idx === 0 ? { ...row, modelId: aiModelAssistantState } : row
      )
    );
  }, [aiModelAssistantState]);

  const mappingDialog = async () => {
    try {
      await dispatch(addLabelMapping(labelRows)).unwrap();
      dispatch(
        fetchLabelsConditionally({
          model_id: aiModelAssistantState,
          ProjectId: lastParam,
        })
      );
      toast.success("Label mapping saved successfully!");
      handleCloseAI();
    } catch (error: any) {
      if (error?.errors) {
        const errorMessages = Object.entries(error.errors)
          .map(([key, value]) => `${key}: ${(value as string[]).join(", ")}`)
          .join("\n");
        toast.error(`Failed to save label mapping:\n${errorMessages}`);
      } else {
        toast.error(`Failed to save label mapping: ${error}`);
      }
    }
  };

  // const mappingDialog = () => {
  //   dispatch(addLabelMapping(labelRows))
  //     .unwrap()
  //     .then(() => {
  //       dispatch(
  //         fetchLabelsConditionally({
  //           model_id: aiModelAssistantState,
  //           ProjectId: lastParam,
  //         })
  //       );
  //       toast.success("Label mapping saved successfully!");
  //       handleCloseAI();
  //     })
  //     .catch((error: any) => {
  //       // Extract detailed error messages if present
  //       if (error?.errors) {
  //         const errorMessages = Object.entries(error.errors)
  //           .map(([key, value]) => `${key}: ${(value as string[]).join(", ")}`)
  //           .join("\n");
  //         toast.error(`Failed to save label mapping:\n${errorMessages}`);
  //       } else {
  //         toast.error(`Failed to save label mapping: ${error}`);
  //       }
  //     });
  // };

  useEffect(() => {
    if (aiModelAssistantState) {
      dispatch(
        fetchLabelsConditionally({
          model_id: aiModelAssistantState,
          ProjectId: lastParam,
        })
      );
    }
  }, [aiModelAssistantState]);

  const handleisDisabled = (labels: any) => {
    console.log(labels.isDisabled);
    dispatch(startSpinner("Saving project label"));
    if (!labels.isDisabled) {
      dispatch(disableProjectLabel(labels.id)).then((data) => {
        dispatch(fetchProjectLabels(lastParam));
        toast.success("label disable successfully");
        dispatch(stopSpinner());
      });
    } else {
      const data = {
        id: labels.id,
        name: labels.name,
        description: "Default Description",
        projectId: labels.projectId,
        type: labels.type,
        objectTracking: labels.objectTracking,
        isDisabled: false,
        labelColor: labels.labelColor,
      };

      dispatch(editProjectLabel(data)).then((data) => {
        dispatch(fetchProjectLabels(lastParam));
        toast.success("label enabled successfully");
        dispatch(stopSpinner());
      });
    }
  };

  return (
    <>
      {loader ? (
        <VisionStudioSpinner spinnerText="" />
      ) : (
        <>
          <Box sx={{ background: "#F5F6F9" }}>
            <Box
              sx={{
                margin: "10px",
                background: "white",
                padding: "10px",
                height: "calc(100vh - 140px)",
              }}
            >
              <Typography
                sx={{
                  color: "#1F4690",
                  fontSize: FONT_SIZE_XXL,
                  fontWeight: "600",
                  paddingBottom: "0",
                  margin: "10px 0",
                }}
              >
                Project Owner: <span>{localStorage.getItem("userName")}</span>
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "20px",
                }}
              >
                {/* Label Map Card */}
                <Card sx={{ position: "relative" }}>
                  <CardHeader
                    sx={{ padding: "0" }}
                    title="Labels"
                    titleTypographyProps={{
                      sx: {
                        color: "#ffffff",
                        fontSize: FONT_SIZE_XXL,
                        fontWeight: "600",
                        padding: "10px",
                        background: "#04307da8",
                        borderTopLeftRadius: "12px",
                        textAlign: "center",
                        borderTopRightRadius: "12px",
                      },
                    }}
                  />

                  <CardContent
                    sx={{
                      padding: "0",
                      paddingBottom: "210px!important",
                      maxHeight: "calc(80vh - 420px)",
                      overflowY: "auto",
                    }}
                  >
                    {/* Add Label Button and Form */}
                    {creator?.ownerId === creator?.currentUser && (
                      <Box
                        sx={{
                          position: "sticky",
                          top: 0,
                          zIndex: 12,
                          background: "inherit",
                          minHeight: 0,
                          mb: 1,
                          display: "flex",
                          justifyContent: "flex-end",
                          pt: 1,
                          pb: 1,
                        }}
                      >
                        <Button
                          size="small"
                          sx={{
                            border: "2px solid #1F4690",
                            background: uploadMembers.length ? "white" : "gray",
                            color: uploadMembers.length ? "gray" : "#fff",
                            width: "40%",
                            padding: "9px",
                            "&:hover": {
                              background: uploadMembers.length
                                ? "white"
                                : "gray",
                            },
                            cursor: uploadMembers.length
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => setShowDiv((prev) => !prev)}
                        >
                          Add Label
                        </Button>
                      </Box>
                    )}

                    {showDiv && (
                      <div
                        style={{
                          background: "white",
                          position: "sticky",
                          top: "47px",
                          zIndex: "11",
                        }}
                      >
                        <form
                          onSubmit={saveAnnotationLabel}
                          style={{ boxShadow: "0 2px 11px #00000047" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: "17px",
                            }}
                          >
                            <TextField
                              id="standard-basic"
                              label="id"
                              variant="standard"
                              type="hidden"
                              value={selectedProjectLabelIdForEdit}
                            />
                            <span
                              style={{
                                height: "17px",
                                width: "17px",
                                background: selectedColor,
                                borderRadius: "4px",
                                marginRight: "10px",
                              }}
                            >
                              <Select
                                value={selectedColor}
                                onChange={handleLabelColorChange}
                                sx={{
                                  padding: "0",
                                  height: "15px",
                                  width: "17px",
                                  border: "none",
                                  "& .MuiInputBase-input": {
                                    border: "none",
                                    padding: "0!important",
                                  },
                                  "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                    padding: "0",
                                  },
                                }}
                                IconComponent={() => null}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: "150px",
                                      width: 250,
                                    },
                                  },
                                }}
                                renderValue={(selected) => {
                                  return (
                                    <span
                                      style={{
                                        flex: "0 0 7%",
                                        height: "17px",
                                        width: "17px",
                                        background: selected,
                                        borderRadius: "4px",
                                        marginRight: "10px",
                                      }}
                                    ></span>
                                  );
                                }}
                              >
                                {colors.map((color) => (
                                  <MenuItem
                                    key={color.value}
                                    value={color.value}
                                  >
                                    <span
                                      style={{
                                        flex: "0 0 7%",
                                        height: "17px",
                                        width: "17px",
                                        background: color.value,
                                        borderRadius: "4px",
                                        marginRight: "10px",
                                      }}
                                    ></span>
                                    {color.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </span>
                            <input
                              type="text"
                              placeholder="Label Name"
                              onKeyDown={(event) => event.stopPropagation()}
                              value={labelName}
                              onChange={handleLabelNameChange}
                              maxLength={50}
                              style={{
                                padding: "8px 9px 9px 15px",
                                fontSize: "16px",
                                outline: "none",
                                margin: "5px 0",
                                width: "85%",
                                flex: "0 0 75%",
                                backgroundColor: "#F5F5F5",
                                border: "1px solid grey",
                                borderRadius: "4px",
                              }}
                            ></input>
                          </div>
                          <Box sx={{ padding: "2px" }}>
                            <Button type="submit">Save</Button>
                            <Button onClick={cancelLabelCreation}>
                              Cancel
                            </Button>
                          </Box>
                        </form>
                      </div>
                    )}
                    {[...labels]
                      .slice()
                      .sort((a, b) => {
                        // Put isDisabled === true at the bottom
                        if (a.isDisabled && !b.isDisabled) return 1;
                        if (!a.isDisabled && b.isDisabled) return -1;
                        return 0;
                      })
                      .map((label) => (
                        <MenuItem value={label.id} id={label.id} key={label.id}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <span
                                style={{
                                  height: "17px",
                                  width: "17px",
                                  minWidth: "17px",
                                  background: label.labelColor,
                                  borderRadius: "4px",
                                  marginRight: "10px",
                                  display: "inline-block",
                                }}
                              ></span>
                              <abbr
                                title={label.name}
                                style={{
                                  textOverflow: "ellipsis",
                                  textDecoration: "none",
                                  width: "178px",
                                  overflow: "hidden",
                                }}
                              >
                                {label.name}
                              </abbr>
                            </Box>
                            {creator?.ownerId === creator?.currentUser && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  onClick={(e) => handleMenuOpen(e, label.id)}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                                {/* OCR INtegration */}
                                {/* <button
                                  // disabled={label.isDisabled}
                                  onClick={() => handleisDisabled(label)}
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: !label?.isDisabled
                                      ? "green"
                                      : "gray",
                                    cursor: "pointer",
                                    transition: "background-color 0.3s ease",
                                  }}
                                /> */}
                              </div>
                            )}
                          </Box>
                        </MenuItem>
                      ))}

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuItem onClick={handleEditProjectLabel}>Edit</MenuItem>
                      <MenuItem
                        onClick={() => {
                          setDeleteProjectLabelModal(true);
                          localStorage.setItem("popupOpen", true.toString());
                        }}
                      >
                        Delete
                      </MenuItem>
                    </Menu>
                    {/* <Box sx={{ paddingTop: "25px" }}>
                      <Typography>
                        AI Model Assistent
                      </Typography>
                      <FormControl fullWidth>
                        <Select
                          labelId="select-option-model"
                          id="select-model"
                          value={""}
                          label="Select Model"
                          size="small"
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: "300px",
                                position: "relative",
                                width: "200px",
                              },
                            },
                          }}
                          sx={{
                            height: "47px",
                            width: "100%",
                            background: "#8f8d8e",
                            borderRadius: "30px",
                            boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                            color: "#ffffff",
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                              borderColor: "transparent",
                            },
                            '& .MuiInputLabel-root': {
                              color: '#ffffff',
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#ffffff',
                            },
                            '& .MuiSelect-select': {
                              color: '#ffffff',
                            },
                            '& .MuiSelect-icon': {
                              color: '#ffffff',
                            }
                          }}
                        >

                          <MenuItem
                            value=""
                            sx={{
                              display: "block",
                              lineHeight: "2",
                              padding: "0 16px",
                              color: '#333',
                              maxHeight: "255px",
                              overflow: "auto",
                            }}
                          >
                            <em>Select Model</em>
                          </MenuItem>
                        
                          <MenuItem value="option1" sx={{ color: '#333' }}>Option One</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option2" sx={{ color: '#333' }}>Option Two</MenuItem>
                          <MenuItem value="option3" sx={{ color: '#333' }}>Option Three</MenuItem>
                        </Select>
                      </FormControl>
                    </Box> */}
                    <div
                      style={{
                        justifyContent: "right",
                        display: "block",
                        position: "absolute",
                        bottom: "10px",
                        width: "96%",
                      }}
                    >
                      <Box sx={{ textAlign: "right" }}>
                        {/* <Button
                          size="small"
                          sx={{
                            border: "2px solid #1F4690",
                            background: uploadMembers.length ? "white" : "gray",
                            color: uploadMembers.length ? "gray" : "#fff",
                            width: "40%",
                            padding: "9px",
                            "&:hover": {
                              background: uploadMembers.length
                                ? "white"
                                : "gray",
                            },
                            cursor: uploadMembers.length
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => setShowDiv((prev) => !prev)}
                        >
                          Add Labels
                        </Button> */}
                        {/* <Button
                          size="small"
                          sx={{
                            border: "2px solid #1F4690",
                            background: uploadMembers.length ? "white" : "gray",
                            color: uploadMembers.length ? "gray" : "#fff",
                            width: "40%",
                            padding: "9px",
                            "&:hover": {
                              background: uploadMembers.length
                                ? "white"
                                : "gray",
                            },
                            cursor: uploadMembers.length
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={handleClickOpenAI}
                        >
                          Map Labels
                        </Button> */}
                      </Box>
                    </div>
                  </CardContent>
                </Card>
                {/* Upload Card */}
                <Card sx={{ position: "relative" }}>
                  <CardHeader
                    sx={{ padding: "0" }}
                    title="Upload"
                    titleTypographyProps={{
                      sx: {
                        color: "#ffffff",
                        fontSize: FONT_SIZE_XXL,
                        fontWeight: "600",
                        padding: "10px",
                        background: "#04307da8",
                        borderTopLeftRadius: "12px",
                        textAlign: "center",
                        borderTopRightRadius: "12px",
                      },
                    }}
                  />

                  <CardContent
                    sx={{ padding: "0", paddingBottom: "210px!important" }}
                  >
                    {renderMemberList(uploadMembers, "upload")}

                    <div
                      style={{
                        justifyContent: "right",
                        display: "block",
                        position: "absolute",
                        bottom: "10px",
                        width: "96%",
                      }}
                    >
                      {renderAddMemberInput(
                        uploadSearchTerm,
                        setUploadSearchTerm,
                        setShowUploadSuggestions,
                        showUploadSuggestions,
                        uploadInputRef,
                        uploadPlaceholder,
                        setUploadPlaceholder,
                        uploadMembers,
                        "upload",
                        uploadInlineLoading,
                        setUploadInlineLoading
                      )}
                      <MemberSummaryBox members={uploadMembers} type="upload" />
                      <Box sx={{ textAlign: "right" }}>
                        {creator?.currentUser === creator?.ownerId && (
                          <Button
                            size="small"
                            sx={{
                              border: "2px solid #1F4690",
                              background: uploadMembers.length
                                ? "white"
                                : "gray",
                              color: uploadMembers.length ? "gray" : "#fff",
                              width: "40%",
                              padding: "9px",
                              "&:hover": {
                                background: uploadMembers.length
                                  ? "white"
                                  : "gray",
                              },
                              cursor: uploadMembers.length
                                ? "pointer"
                                : "not-allowed",
                            }}
                            onClick={() =>
                              uploadMembers.length
                                ? handleOpen(uploadMembers, "upload")
                                : null
                            }
                          >
                            Set Targets
                          </Button>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                </Card>
                {/* Annotate Card */}
                <Card sx={{ position: "relative" }}>
                  <CardHeader
                    sx={{ padding: "0" }}
                    title="Annotate"
                    titleTypographyProps={{
                      sx: {
                        color: "#ffffff",
                        fontSize: FONT_SIZE_XXL,
                        fontWeight: "600",
                        padding: "10px",
                        background: "#04307da8",
                        borderTopLeftRadius: "12px",
                        textAlign: "center",
                        borderTopRightRadius: "12px",
                      },
                    }}
                  />
                  <CardContent
                    sx={{ padding: "0", paddingBottom: "210px!important" }}
                  >
                    {renderMemberList(annotateMembers, "annotate")}
                    <div
                      style={{
                        justifyContent: "right",
                        display: "block",
                        position: "absolute",
                        bottom: "10px",
                        width: "96%",
                      }}
                    >
                      {renderAddMemberInput(
                        annotateSearchTerm,
                        setAnnotateSearchTerm,
                        setShowAnnotateSuggestions,
                        showAnnotateSuggestions,
                        annotateInputRef,
                        annotatePlaceholder,
                        setAnnotatePlaceholder,
                        annotateMembers,
                        "annotate",
                        annotateInlineLoading,
                        setAnnotateInlineLoading
                      )}
                      <MemberSummaryBox
                        members={annotateMembers}
                        type="annotate"
                      />
                      <Box sx={{ textAlign: "right" }}>
                        {creator?.currentUser === creator?.ownerId && (
                          <Button
                            size="small"
                            sx={{
                              border: "2px solid #1F4690",
                              background: annotateMembers.length
                                ? "white"
                                : "gray",
                              color: annotateMembers.length ? "gray" : "#fff",
                              width: "40%",
                              padding: "9px",
                              "&:hover": {
                                background: annotateMembers.length
                                  ? "white"
                                  : "gray",
                              },
                              cursor: annotateMembers.length
                                ? "pointer"
                                : "not-allowed",
                            }}
                            onClick={() =>
                              annotateMembers.length
                                ? handleOpen(annotateMembers, "annotate")
                                : null
                            }
                          >
                            Set Targets
                          </Button>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                </Card>
                {/* Train Card */}
                <Card sx={{ position: "relative" }}>
                  <CardHeader
                    sx={{ padding: "0" }}
                    title="Train"
                    titleTypographyProps={{
                      sx: {
                        color: "#ffffff",
                        fontSize: FONT_SIZE_XXL,
                        fontWeight: "600",
                        padding: "10px",
                        background: "#04307da8",
                        borderTopLeftRadius: "12px",
                        textAlign: "center",
                        borderTopRightRadius: "12px",
                      },
                    }}
                  />
                  <CardContent
                    sx={{ padding: "0", paddingBottom: "210px!important" }}
                  >
                    {renderMemberList(trainMembers, "train")}
                    <div
                      style={{
                        justifyContent: "right",
                        display: "block",
                        position: "absolute",
                        bottom: "10px",
                        width: "96%",
                      }}
                    >
                      {renderAddMemberInput(
                        trainSearchTerm,
                        setTrainSearchTerm,
                        setShowTrainSuggestions,
                        showTrainSuggestions,
                        trainInputRef,
                        trainPlaceholder,
                        setTrainPlaceholder,
                        trainMembers,
                        "train",
                        trainInlineLoading,
                        setTrainInlineLoading
                      )}
                      <MemberSummaryBox members={trainMembers} />
                      <Box sx={{ textAlign: "right", mt: 0.5 }}>
                        {creator?.currentUser === creator?.ownerId && (
                          <Button
                            size="small"
                            sx={{
                              border: "2px solid #1F4690",
                              background: trainMembers.length
                                ? "white"
                                : "gray",
                              color: trainMembers.length ? "gray" : "#fff",
                              width: "40%",
                              padding: "9px",
                              "&:hover": {
                                background: trainMembers.length
                                  ? "white"
                                  : "gray",
                              },
                              cursor: trainMembers.length
                                ? "pointer"
                                : "not-allowed",
                            }}
                            onClick={() =>
                              trainMembers.length
                                ? handleOpen(trainMembers, "train")
                                : null
                            }
                          >
                            Set Targets
                          </Button>
                        )}
                      </Box>
                    </div>
                  </CardContent>
                </Card>
                {/* done text below the cards */}
                {creator?.ownerId === creator?.currentUser &&
                  !taskType?.toLowerCase().includes("classification") && (
                    <>
                      {listofAiModels.length > 0 ? (
                        <>
                          <FormControl
                            sx={{ width: "100%", marginTop: "20px" }}
                          >
                            <Typography>AI Model Assistant</Typography>

                            <Select
                              id="modelType"
                              value={aiModelAssistantState}
                              displayEmpty
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              size="small"
                              sx={{
                                background: "#F1F3F4",
                                "& .MuiSelect-select": {
                                  color: "#666",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                              }}
                              onChange={(e) =>
                                setAiModelAssistantState(e.target.value)
                              }
                            >
                              <MenuItem value={""} disabled>
                                Select Model Type
                              </MenuItem>
                              {listofAiModels.map((item) => (
                                <MenuItem
                                  key={item.modelId}
                                  value={item.modelId}
                                  disabled={disabledIds.includes(
                                    item.modelId.toLowerCase()
                                  )}
                                >
                                  <span style={{ width: "100%" }}>
                                    {item.name}
                                  </span>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {aiModelAssistantState && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-start",
                              mt: 2,
                            }}
                          >
                            <Button
                              size="small"
                              disabled={loading || !uploadMembers.length}
                              sx={{
                                border: "2px solid #1F4690",
                                background: uploadMembers.length
                                  ? "white"
                                  : "gray",
                                color: uploadMembers.length ? "gray" : "#fff",
                                width: "40%",
                                padding: "9px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 1,
                                "&:hover": {
                                  background: uploadMembers.length
                                    ? "white"
                                    : "gray",
                                },
                                cursor: uploadMembers.length
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              onClick={() => {
                                setLoading(true);
                                const fetchAction =
                                  listofAiLabels.length &&
                                  aiModelAssistantState ===
                                    listofAiLabels[0].modelId
                                    ? fetchLabelsConditionally({
                                        model_id: aiModelAssistantState,
                                        ProjectId: lastParam,
                                      })
                                    : fetchListOfAiLabels({
                                        model_id: aiModelAssistantState,
                                      });

                                dispatch(fetchAction)
                                  .then(handleClickOpenAI)
                                  .finally(() => setLoading(false));
                              }}
                            >
                              {loading ? (
                                <CircularProgress size={16} />
                              ) : (
                                "Map Labels"
                              )}
                            </Button>
                          </Box>
                          )}
                        </>
                      ) : (
                        <Typography sx={{ color: "red" }}>
                          No models available for AI Assist
                        </Typography>
                      )}
                    </>
                  )}{" "}
              </Box>
            </Box>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 500,
                  bgcolor: "background.paper",
                  borderRadius: "10px",
                  boxShadow: 24,
                  p: 4,
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                  padding: "20px",
                }}
              >
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{ fontSize: FONT_SIZE_XL, color: "#000000" }}
                >
                  Assign targets to members
                </Typography>
                {targetModalData?.cardType == "annotate" ? (
                  <Box sx={{ width: "100%", margin: "auto" }}>
                    <Slider
                      value={value}
                      onChange={handleChange}
                      valueLabelDisplay="auto"
                      valueLabelFormat={(value) => `${value} Images`}
                      min={0}
                      max={creator?.unassignedImages}
                      step={1}
                    />

                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box sx={{ fontSize: FONT_SIZE_XS, color: "black" }}>
                        <span>
                          {
                            <span>
                              {(creator?.unassignedImages ?? 0) - value}
                            </span>
                          }
                        </span>{" "}
                        &nbsp;Unassigned Images
                      </Box>

                      <Box>
                        <Typography
                          sx={{ fontSize: FONT_SIZE_XS, color: "black" }}
                        >
                          Assigned Images: {value}/{creator?.unassignedImages}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}

                <TableContainer
                  component={Paper}
                  sx={{
                    maxWidth: 700,
                    margin: "10px auto",
                    maxHeight: "calc(90vh - 150px)",
                    overflowY: "auto",
                  }}
                >
                  <Table>
                    <TableHead
                      sx={{
                        background: "#dbdbdb",
                        position: "relative",
                        zIndex: "9",
                      }}
                    >
                      <TableRow
                        sx={{ position: "sticky", top: 0, background: "#fff" }}
                      >
                        <TableCell sx={{ padding: "10px" }}>
                          <strong>Name</strong>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: "150px",
                            padding: "10px",
                          }}
                        >
                          <strong>Target</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {targetModalData?.members.map((member) => (
                        <TableRow key={member.ownerId}>
                          <TableCell sx={{ padding: "8px" }}>
                            {targetModalData.cardType === "annotate" ? (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={!!member.track}
                                    onChange={(e) => {
                                      const checked = e.target.checked;

                                      // Step 1: Update track for the clicked user
                                      const newMembers =
                                        targetModalData.members.map((m) =>
                                          m.ownerId === member.ownerId
                                            ? { ...m, track: checked }
                                            : m
                                        );

                                      // Step 2: Distribute targets among updated tracked users
                                      const trackedMembers = newMembers.filter(
                                        (m) => m.track
                                      );
                                      const trackedCount =
                                        trackedMembers.length;
                                      const totalValue = value; // from your state

                                      let baseValue = 0;
                                      let remainder = 0;

                                      if (trackedCount > 0) {
                                        baseValue = Math.floor(
                                          totalValue / trackedCount
                                        );
                                        remainder = totalValue % trackedCount;
                                      }

                                      let distributed = 0;

                                      const updatedMembers = newMembers.map(
                                        (m) => {
                                          if (m.track) {
                                            const extra =
                                              distributed === 0 ? remainder : 0;
                                            distributed++;
                                            const newTarget = baseValue + extra;

                                            return {
                                              ...m,
                                              target: newTarget,
                                              annotationTarget: newTarget,
                                            };
                                          }

                                          return {
                                            ...m,
                                            target: 0,
                                            ...(targetModalData.cardType ===
                                              "annotate" && {
                                              annotationTarget: 0,
                                            }),
                                          };
                                        }
                                      );

                                      setTargetModalData({
                                        ...targetModalData,
                                        members: updatedMembers,
                                      });
                                    }}
                                  />
                                }
                                label={member.userName}
                                sx={{ width: "100%" }}
                              />
                            ) : (
                              <span>{member.userName}</span>
                            )}
                          </TableCell>

                          <TableCell sx={{ padding: "8px" }}>
                            <TextField
                              type="number"
                              inputProps={{ min: 0, max: 999999 }}
                              value={
                                targetModalData.cardType === "upload"
                                  ? member.imageTarget ?? ""
                                  : targetModalData.cardType === "annotate"
                                  ? member.annotationTarget ?? ""
                                  : targetModalData.cardType === "train"
                                  ? member.trainTarget ?? ""
                                  : member.target ?? ""
                              }
                              onChange={(e) => {
                                let inputValue = e.target.value;
                                let inputTarget =
                                  inputValue === ""
                                    ? undefined
                                    : parseInt(inputValue) || 0;
                                if (typeof inputTarget === "number") {
                                  if (inputTarget > 999999)
                                    inputTarget = 999999;
                                  if (inputTarget < 0) inputTarget = 0;
                                }
                                const updatedMembers =
                                  targetModalData.members.map((m) => {
                                    if (m.ownerId === member.ownerId) {
                                      const updatedMember = {
                                        ...m,
                                      };
                                      if (
                                        targetModalData.cardType === "upload"
                                      ) {
                                        updatedMember.imageTarget = inputTarget;
                                        updatedMember.target = inputTarget;
                                      } else if (
                                        targetModalData.cardType === "annotate"
                                      ) {
                                        updatedMember.annotationTarget =
                                          inputTarget;
                                        updatedMember.target = inputTarget;
                                      } else if (
                                        targetModalData.cardType === "train"
                                      ) {
                                        if ("target" in updatedMember)
                                          delete updatedMember.target;
                                        updatedMember.trainTarget = inputTarget;
                                      } else {
                                        updatedMember.target = inputTarget;
                                      }
                                      return updatedMember;
                                    }
                                    return m;
                                  });

                                setTargetModalData({
                                  ...targetModalData,
                                  members: updatedMembers,
                                });
                              }}
                              disabled={targetModalData.cardType === "annotate"}
                              sx={{
                                cursor:
                                  targetModalData.cardType === "annotate"
                                    ? "not-allowed"
                                    : "",
                              }}
                              variant="outlined"
                              size="small"
                              fullWidth
                              onKeyDown={(e) => {
                                if (e.key === "+" || e.key === "-") {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box>
                  <div
                    style={{
                      display: "flex",
                      padding: "10px",
                      gap: "20px",
                      justifyContent: "end",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleSave}
                      disabled={
                        !targetModalData?.members?.length ||
                        targetModalData.members.every((m) => {
                          if (targetModalData.cardType === "upload")
                            return !m.imageTarget || m.imageTarget === 0;
                          if (targetModalData.cardType === "annotate")
                            return (
                              !m.annotationTarget || m.annotationTarget === 0
                            );
                          if (targetModalData.cardType === "validate")
                            return !m.target || m.target === 0;
                          if (targetModalData.cardType === "train")
                            return !m.trainTarget || m.trainTarget === 0;
                          return true;
                        })
                      }
                    >
                      Save
                    </Button>
                    <Button variant="outlined" onClick={handleCancel}>
                      Cancel
                    </Button>
                  </div>
                </Box>
              </Box>
            </Modal>
          </Box>
        </>
      )}
      <Dialog
        open={openAI}
        onClose={handleCloseAI}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: "rounded-xl shadow-2xl p-6 w-full mx-auto",
          sx: {
            boxShadow: "none",
            width: "50%",
            maxWidth: "50%",
            height: "70%",
            maxHeight: "70%",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        }}
      >
        <DialogTitle className="text-2xl font-bold text-gray-900 pb-4 border-b border-gray-200">
          Map Your Labels
        </DialogTitle>
        <DialogContent className="py-6" sx={{}}>
          <Typography variant="h6" sx={{ flexShrink: 0, mb: 2 }}>
            Model Name:&nbsp;
            <span style={{ fontWeight: 600 }}>
              {aiModelAssistantState
                ? listofAiModels.find(
                    (m) => m.modelId === aiModelAssistantState
                  )?.name || "Model Name"
                : "Model Name"}
            </span>
          </Typography>
          <Box sx={{ display: "flex", fontWeight: 600, mb: 1 }}>
            <span style={{ flex: 1 }}>Name</span>
            <span style={{ flex: 1 }}>Label</span>
          </Box>
          {labelRows.map((row, idx) => (
            <Box
              key={idx}
              sx={{ display: "flex", alignItems: "center", mb: 2 }}
            >
              <Typography
                variant="body2"
                sx={{
                  px: 1.5,
                  py: 1,
                  // border: "1px solid rgba(0, 0, 0, 0.23)",
                  // borderRadius: 1,
                  fontSize: "0.875rem",
                  color: "#000",
                  width: "48%",
                }}
              >
                {row.labelName || "Label Name"}
              </Typography>
              {/* Set modelId to aiModelAssistantState */}

              <FormControl size="small" sx={{ width: "48%", mr: 1 }}>
                <Select
                  value={row.projectLabelId}
                  label="Map Label"
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "250px",
                        position: "relative",
                        width: "270px",
                        overflow: "auto",
                      },
                    },
                  }}
                  sx={{
                    background: "#0000001A",
                    borderRadius: "6px",
                    boxShadow: "1.46px 2.92px 2.92px -0.73px #00000040 inset",
                    color: "#000",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      borderColor: "transparent",
                    },
                    "& .MuiInputLabel-root": {
                      color: "#000",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#000",
                    },
                    "& .MuiSelect-select": {
                      color: "#000",
                    },
                    "& .MuiSelect-icon": {
                      color: "#000",
                    },
                  }}
                  onChange={(e) =>
                    handleLabelRowChange(
                      idx,
                      "projectLabelId",
                      e.target.value as string
                    )
                  }
                >
                  <MenuItem value="">
                    <em>Map Label</em>
                  </MenuItem>
                  {labels
                    // .filter(label =>
                    //   // Only show labels not already selected in other rows (except current row)
                    //   !labelRows.some((r, i) => r.projectLabelId === label.id && i !== idx)
                    // )
                    .map((label) => (
                      <MenuItem
                        key={label.id}
                        value={label.id}
                        sx={{ color: "#333" }}
                      >
                        {label.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              {/* Set projectId to lastParam */}

              {/* Add or Remove icon */}
              {/* {idx === labelRows.length - 1 ? (
                <IconButton onClick={handleAddLabelRow} sx={{ color: "#1976d2" }}>
                  <AddIcon />
                </IconButton>
              ) : (
                <IconButton onClick={() => handleRemoveLabelRow(idx)} sx={{ color: "#f44336" }}>
                  <span style={{ fontWeight: "bold", fontSize: 18 }}>×</span>
                </IconButton>
              )} */}
            </Box>
          ))}
        </DialogContent>
        {/* Dialog Actions (buttons at the bottom) */}
        <DialogActions className="pt-4 border-t border-gray-200 flex justify-end gap-3">
          <Button
            onClick={() => {
              setLabelRows([
                {
                  labelName: "",
                  modelId: "",
                  projectLabelId: "",
                  projectId: "",
                },
              ]);
              handleCloseAI();
            }}
            className="text-blue-600 hover:text-blue-800 font-semibold py-2 px-4 rounded-lg transition duration-200 ease-in-out"
            sx={{ textTransform: "none", borderRadius: "0.5rem" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg shadow-sm transition duration-200 ease-in-out"
            sx={{ textTransform: "none", borderRadius: "0.5rem" }}
            autoFocus
            disabled={isConfirmLoading}
            onClick={async () => {
              setIsConfirmLoading(true);
              try {
                await mappingDialog();
              } finally {
                setIsConfirmLoading(false);
              }
            }}
          >
            {isConfirmLoading ? "Loading..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteProjectLabelModal}
        onClose={() => {
          setDeleteProjectLabelModal(false);
          localStorage.setItem("popupOpen", false.toString());
        }}
        PaperProps={{
          style: {
            boxShadow: "none",
            width: "50%",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "#2121210f",
            },
          },
        }}
      >
        <DialogTitle>Delete Project Label</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you want to delete this Label?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="calcelDeleteLabel" onClick={handleDeleteLabelClose}>
            Cancel
          </Button>
          <Button id="confirmDeleteLabel" onClick={handleProjectLabelDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WorkFlow;
